import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { BookingService } from './../models/booking.service';
import { DriverModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-select-driver-popup',
  template: require('../views/select-driver-popup.component.html'),
  providers: [DriverService]
})

export class SelectDriverPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  driverList: DriverModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  @Input() CompanyHashId: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;

  constructor(private driverService: DriverService
    , private bookingService: BookingService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetDriverList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetDriverList() {
    this.isLoading = true;
    this.bookingService.GetActiveDriverList(this.DataListModel, this.CompanyHashId)
      .subscribe(
        res => {
          this.driverList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  private select(driver: DriverModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName, instanceLanguage: driver.instanceLanguage });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/select-driver-popup.component.ts